import { useLayoutEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import clsx from 'clsx'

import TableRowsNarrow from '@mui/icons-material/TableRows'
import WindowIcon from '@mui/icons-material/Window'
import IconButton from '@mui/material/IconButton'

import FiltersChips from '../../components/filters/FiltersChips'
import UnitSkeleton from '../../components/UnitSkeleton'
import Filters from '../../components/filters/filters'
import ToolBar from '../../components/toolBar'
import UsePaginator from './usePaginator'

import { getUnits, setViewType } from '../../actions/viewerActions'
import useWindowSize from '../../hooks/useWindowsSize'

import UseMiniMap from './useMiniMap'
import UnitsCard from './unitsCard'
import UnitList from './unitsList'

import { classes, SearchStyle } from './style'

const minimapContainerStyle = (type) => {
  return clsx({
    [classes.miniMapSide]: true,
    [classes.showMapSide]: type === 'map'
  })
}

const gridContainerStyle = (type) => {
  return (
    clsx({
      [classes.listSide]: true,
      [classes.hiddenListSide]: type === 'map'
    })
  )
}

// eslint-disable-next-line react/prop-types
const ToolbarImplementation = ({ width, type, dispatch }) => {
  return (
    <ToolBar>
      {width >= 900 && <>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ ml: 2 }}
          style={{ color: 'gray' }}
          className={clsx({ [classes.activeIcon]: type === 'grid' })}
          onClick={() => {
            dispatch(setViewType('grid'))
          }}
        >
          <WindowIcon/>
        </IconButton>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ ml: 2 }}
          style={{ color: 'gray' }}
          className={clsx({ [classes.activeIcon]: type === 'list' })}
          onClick={() => {
            dispatch(setViewType('list'))
          }}
        >
          <TableRowsNarrow/>
        </IconButton>
      </>}
    </ToolBar>
  )
}

const SearchPanel = () => {
  const [width] = useWindowSize()

  const loadingStatus = useSelector(state => state.viewer.loading)
  const viewType = useSelector(state => state.viewer.viewType)
  const units = useSelector(state => state.viewer.units)
  const max = useSelector(state => state.viewer.max)
  const type = useSelector(state => state.viewer.viewType)
  const dispatch = useDispatch()

  useLayoutEffect(() => {
    if (!units.length) {
      dispatch(getUnits({ max, page: 1 }))
    }
  }, [])

  return (
    <>
      <ToolbarImplementation width={width} type={type} dispatch={dispatch}/>
      <SearchStyle className={classes.root}>
        <Filters/>
        <div className={classes.searchContainer}>
          <div className={gridContainerStyle(type)} >
          { loadingStatus && <UnitSkeleton repeat={9} type={viewType}/> }
          { !loadingStatus &&
            <>
              <FiltersChips/>
              {(viewType === 'list' && width >= 900) && <UnitList/>}
              {(viewType === 'grid' || width < 900) && <UnitsCard/>}
              {!isEmpty(units) && <UsePaginator/>}
            </>
          }
            </div>
          <div className={minimapContainerStyle(type)}>
            <UseMiniMap/>
          </div>
        </div>
      </SearchStyle>
    </>
  )
}

export default SearchPanel
